import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SessionSelectors } from '@next/core-lib/session';
import { Store } from '@ngrx/store';

import { catchError, map, of, switchMap, withLatestFrom } from 'rxjs';

import { loadBFPData, loadBFPDataFailure, loadBFPDataSuccess } from './bfp.actions';
import { BemApiService } from '../shared/services/bem-api.service';
import { cropYearChanged } from '../../store/actions';


@Injectable()
export class BfpEffects {
  private readonly actions$ = inject(Actions);
  private readonly bemService = inject(BemApiService);
  private readonly store = inject(Store);

  cropYearChanged$ = createEffect(() =>
    this.actions$.pipe(
      ofType(cropYearChanged),
      map(({ cropYear }) => loadBFPData({ year: cropYear })),
    ),
  );

  loadBfps$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadBFPData),
      // Dashboard activation only requires a session; full customer details may still be loading.
      withLatestFrom(this.store.select(SessionSelectors.selectSessionCustomerId)),
      switchMap(([action, customerId]) =>
        this.bemService.getCropFieldNutrientCalculation(action.payload.year).pipe(
          map((data) => loadBFPDataSuccess({ data, customerId: customerId ?? null })),
          catchError((error) =>
            of(loadBFPDataFailure({ error: error.message })),
          ),
        ),
      ),
    ),
  );
}
